import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteBroker = ({
    setDeleteBroker,
    selectedData,
    deleteBrokerLoading,
    deleteBrokerMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteBrokerMutate({
            id: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setDeleteBroker}
            title="Confirm Deletion"
        >
            <WarningText>
                {/* Are you sure you want to delete this broker? */}
                Are you sure you want to delete the Broker ‘{selectedData?.name}’?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteBrokerLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteBrokerLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteBroker;